module.exports = __webpack_public_path__ + "static/media/enj.9bd83db9.svg";